import React, {CSSProperties} from 'react'
import styled, {css} from 'styled-components'
import {WINDOW_MODE_MOBILE_WIDTH} from 'consts'
import {Paragraph} from 'common/components'
import convertUnit from 'lib/unit'
import {TransactionCheckoutInfoItemProps} from './TransactionInfoItemProps'

interface StyledDescriptionProps {
  textAlign?: CSSProperties['textAlign']
}

const StyledContainer = styled.div`
  display: flex;
  flex-direction: row;
  box-sizing: border-box;
  justify-content: space-between;
`

const StyledTitle = styled(Paragraph)`
  text-align: left;
`

const StyledDescription = styled(Paragraph)<StyledDescriptionProps>`
  ${({textAlign}) => {
    const isLeft = textAlign === 'left'
    return css`
      text-align: ${textAlign || 'right'};
      width: ${isLeft ? '35%' : undefined};
      @media (max-width: ${WINDOW_MODE_MOBILE_WIDTH}px) {
        width: ${isLeft ? '40%' : undefined};
      }
    `
  }}
`

export default function TransactionInfoItem({
  title,
  description,
  totalPrice,
  boldDescription,
  descriptionPosition,
  details,
  ...props
}: TransactionCheckoutInfoItemProps) {
  return details ? (
    <StyledContainer {...props}>
      <StyledTitle color="gray_4">{title}</StyledTitle>
      <StyledDescription color="gray_4">{description}</StyledDescription>
    </StyledContainer>
  ) : (
    <StyledContainer style={{marginTop: convertUnit(10)}} {...props}>
      <StyledTitle fontSize="m" fontWeight="medium">
        {title}
      </StyledTitle>
      <StyledDescription
        fontSize="m"
        fontWeight={boldDescription ? 'bold' : 'regular'}
        color={totalPrice ? 'primary_5' : 'black'}
        textAlign={descriptionPosition}>
        {description}
      </StyledDescription>
    </StyledContainer>
  )
}
